import { createResultsUrl } from "@lib/searchUtils"
import { navigate } from "gatsby"
import { usePropertyStore } from "../store/propertyStore"
// import { useEffect } from "react"
// import { useGlobalStore } from "@stores/globalStore"

const useSearch = ({ onClick } = {}) => {
  // const { currencyType } = useGlobalStore()
  const {
    buildingType,
    pDepartment,
    pType,
    minBedroom,
    maxBedroom,
    minPrice,
    maxPrice,
    minAreaSize,
    maxAreaSize,
    sortBy,
    selectedAreas,
    selectedAmenities,
    offplanStatus,
    developer,
    furnished,
    crmId,
    statusType,
    city,
    // minPriceOptions,
    // maxPriceOptions,
    // setMinPriceOptions,
    // setMaxPriceOptions,
    // setMinPrice,
    // setMaxPrice,
  } = usePropertyStore()
  //   (state) => ({
  //   setMinPriceOptions: state.setMinPriceOptions,
  //   setMaxPriceOptions: state.setMaxPriceOptions,
  //   minPriceOptions: state.minPriceOptions,
  //   maxPriceOptions: state.maxPriceOptions,
  //   setMinPrice: state.setMinPrice,
  //   setMaxPrice: state.setMaxPrice,
  //   minPrice: state.minPrice,
  //   maxPrice: state.maxPrice,
  // })

  const handleSearch = () => {
    // window.onbeforeunload = null
    const url = createResultsUrl({
      departmentVal: pDepartment,
      searchTypeVal: pType,
      areaVal: selectedAreas,
      minBedVal: minBedroom?.value,
      maxBedVal: maxBedroom?.value,
      minPriceVal: minPrice?.value,
      maxPriceVal: maxPrice?.value,
      minAreaSizeVal: minAreaSize?.value,
      maxAreaSizeVal: maxAreaSize?.value,
      buildingVal: buildingType?.value,
      sortVal: sortBy?.value,
      amenitiesVal: selectedAmenities,
      offplanStatusVal: offplanStatus?.value,
      developerVal: developer?.value,
      furnishVal: furnished,
      crm_id: crmId,
      statusTypeVal:statusType,
      cityVal: selectedAreas?.length > 0 ? "" : city?.value
    })
    // useEffect(() => {
    //   const convertedMinPriceOptions = minPriceOptions?.map((option) => ({
    //     value: option.value,
    //     label:
    //       option.value === ""
    //         ? option.label
    //         : currencyType?.value === "AED"
    //         ? `${currencyType?.label} ${option.value}`
    //         : `${currencyType?.label} ${parseInt(
    //             calcPrice(option.value, currencyType?.value, "AED")
    //           ).toLocaleString("en-US")}`,
    //   }))
    //   if (!isEmpty(convertedMinPriceOptions))
    //     setMinPriceOptions(convertedMinPriceOptions)
    //   const convertedMinPrice = {
    //     label:
    //       minPrice?.value === ""
    //         ? minPrice?.label
    //         : `${currencyType?.label} ${parseInt(
    //             calcPrice(minPrice?.value, currencyType?.value, "AED")
    //           ).toLocaleString("en-US")}`,
    //     value: minPrice?.value,
    //   }
    //   if (!isEmpty(convertedMinPrice)) setMinPrice(convertedMinPrice)
    //   const convertedMaxPriceOptions = maxPriceOptions?.map((option) => ({
    //     value: option.value,
    //     label:
    //       option.value === ""
    //         ? option.label
    //         : currencyType?.value === "AED"
    //         ? `${currencyType?.label} ${option.value}`
    //         : `${currencyType?.label} ${parseInt(
    //             calcPrice(option.value, currencyType?.value, "AED")
    //           ).toLocaleString("en-US")}`,
    //   }))

    //   if (!isEmpty(convertedMaxPriceOptions))
    //     setMaxPriceOptions(convertedMaxPriceOptions)
    //   const convertedMaxPrice = {
    //     label:
    //       maxPrice?.value === ""
    //         ? "No Max"
    //         : `${currencyType?.label} ${parseInt(
    //             calcPrice(maxPrice?.value, currencyType?.value, "AED")
    //           ).toLocaleString("en-US")}`,
    //     value: maxPrice?.value,
    //   }

    //   if (!isEmpty(convertedMaxPrice)) setMaxPrice(convertedMaxPrice)
    // }, [])
    // navigate(url)
    // console.log(url)
    // console.log(window.location.pathname)
    if(window.location.pathname === url){

    }
    else {
      // window.location.replace(url)
      navigate(url)
    }
    onClick && onClick()
  }

  const handleClear = () => {
    const url = createResultsUrl({
      departmentVal: pDepartment,
      searchTypeVal: pType,
      sortVal: sortBy?.value,
    })

    navigate(url)
    // window.location.href = url
    // window.location.replace(url)
    onClick && onClick()
  }

  return {
    handleSearch,
    handleClear,
  }
}

export default useSearch
